import Table from 'material-ui-next/Table'
import TableBody from 'material-ui-next/Table/TableBody'
import TableCell from 'material-ui-next/Table/TableCell'
import TableHead from 'material-ui-next/Table/TableHead'
import TableRow from 'material-ui-next/Table/TableRow'
import AppBar from 'material-ui/AppBar'
import IconButton from 'material-ui/IconButton'
import LinearProgress from 'material-ui/LinearProgress'
import NavigationMenu from 'material-ui/svg-icons/navigation/menu'
import * as R from 'ramda'
import * as React from 'react'
import injectSheet from 'react-jss'
import { url } from '../../App/AuthenticatedRoute'
import { PrismaRequestFilterContainer } from '../../Components/PrismaRequestFiltering/View/PrismaRequestFilterContainer'
import { formatPrice } from '../../Data/NumberHelper'
import * as PrismaRequestOfferType from '../../Entities/PrismaRequestOfferType'
import { Footer } from '../../View/Footer'
import { WithClasses } from '../../View/Helper'
import { LinkTableCell } from '../../View/LinkTableCell'
import { PageSize } from '../../View/PageSize'
import { PaginationView } from '../../View/PaginationView'
import { PrismaManufacturerStatusView } from '../../View/PrismaManufacturerStatusView'
import { PrismaRequestOverviewAction } from './PrismaRequestOverviewActions'
import { PrismaRequestOverviewState } from './PrismaRequestOverviewState'
import * as PrismaRequestWithOffersForList from '../../Entities/PrismaRequestWithOffersForList'

const styles = {
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    overviewWrapper: {
        overflowY: 'scroll',
        flex: '1',
    },
}

interface Properties {
    readonly state: PrismaRequestOverviewState
    readonly dispatch: (action: PrismaRequestOverviewAction) => void
}

function generateTableEntry(prismaRequestWithOffers: PrismaRequestWithOffersForList.M) {
    const
        {
            prismaRequest,
            prismaRequestOffersWithManufacturerStatus,
            prismaRequestManufacturerStatus,
            printProduct,
            customerId,
        } = prismaRequestWithOffers,
        href = url({
                       type: 'PrismaRequestDetails',
                       id: prismaRequest.id,
                   })

    if (prismaRequestOffersWithManufacturerStatus === null || prismaRequestOffersWithManufacturerStatus.length === 0) {
        return (
            <TableRow key={'request-' + prismaRequest.id}>
                <LinkTableCell
                    href={href}
                    smallPadding={true}
                >
                    {prismaRequest.id}
                </LinkTableCell>

                <LinkTableCell
                    href={href}
                    smallPadding={true}
                >
                    <img
                        width={'36px'}
                        height={'36px'}
                        src={
                            customerId === 7
                                ? '/img/rwe.png'
                                : customerId === 14
                                    ? '/img/innogy.png'
                                    : '/img/eon.png'
                        }
                    />
                </LinkTableCell>

                <LinkTableCell href={href}>
                    {prismaRequest.name}
                </LinkTableCell>

                <LinkTableCell
                    href={href}
                    numeric={true}
                >
                    {prismaRequest.amount}
                </LinkTableCell>

                <LinkTableCell
                    href={href}
                    numeric={true}
                >
                    {printProduct.packingQuantity}
                </LinkTableCell>

                <LinkTableCell
                    href={href}
                    numeric={true}
                >
                    {prismaRequest.amount * printProduct.packingQuantity}
                </LinkTableCell>

                <LinkTableCell href={href}>
                    {prismaRequest.isStandardProductRequest ? 'Standard' : 'Individuell'}
                </LinkTableCell>

                <LinkTableCell href={href}>
                    {PrismaRequestOfferType.label('Print')}
                </LinkTableCell>

                <LinkTableCell
                    href={href}
                    numeric={true}
                >
                    {prismaRequest.netPrintPrice !== null ? formatPrice(prismaRequest.netPrintPrice) : '-'}
                </LinkTableCell>

                <LinkTableCell href={href}>
                    <PrismaManufacturerStatusView
                        status={prismaRequestManufacturerStatus !== null ? prismaRequestManufacturerStatus : 'Inactive'}
                    />
                </LinkTableCell>
            </TableRow>
        )
    } else {
        let first = true
        return R.flatten(R.map(
            prismaRequestOfferWithManufacturerStatus => {
                const
                    {
                        prismaRequestOffer,
                        manufacturerStatus,
                    } = prismaRequestOfferWithManufacturerStatus

                let elements = (
                    <TableRow key={'request-' + prismaRequestOffer.prismaRequestId + 'offer-' + prismaRequestOffer.id}>
                        {first &&
                        <LinkTableCell
                            smallPadding={true}
                            href={href}
                            rowSpan={prismaRequestOffersWithManufacturerStatus.length}
                        >
                            {prismaRequest.id}
                        </LinkTableCell>
                        }

                        {first &&
                        <LinkTableCell
                            href={href}
                            smallPadding={true}
                            rowSpan={prismaRequestOffersWithManufacturerStatus.length}
                        >
                            <img
                                width={'36px'}
                                height={'36px'}
                                src={
                                    customerId === 7
                                        ? '/img/rwe.png'
                                        : customerId === 14
                                            ? '/img/innogy.png'
                                            : '/img/eon.png'
                                }
                            />
                        </LinkTableCell>
                        }

                        {first &&
                        <LinkTableCell
                            href={href}
                            rowSpan={prismaRequestOffersWithManufacturerStatus.length}
                        >
                            {prismaRequest.name}
                        </LinkTableCell>
                        }

                        {first &&
                        <LinkTableCell
                            href={href}
                            numeric={true}
                            rowSpan={prismaRequestOffersWithManufacturerStatus.length}
                        >
                            {prismaRequest.amount}
                        </LinkTableCell>
                        }

                        {first &&
                        <LinkTableCell
                            href={href}
                            numeric={true}
                            rowSpan={prismaRequestOffersWithManufacturerStatus.length}
                        >
                            {printProduct.packingQuantity}
                        </LinkTableCell>
                        }

                        {first &&
                        <LinkTableCell
                            href={href}
                            numeric={true}
                            rowSpan={prismaRequestOffersWithManufacturerStatus.length}
                        >
                            {prismaRequest.amount * printProduct.packingQuantity}
                        </LinkTableCell>
                        }

                        {first &&
                        <LinkTableCell
                            href={href}
                            rowSpan={prismaRequestOffersWithManufacturerStatus.length}
                        >
                            {prismaRequest.isStandardProductRequest ? 'Standard' : 'Individuell'}
                        </LinkTableCell>
                        }

                        <LinkTableCell href={href}>
                            {PrismaRequestOfferType.label(prismaRequestOffer.type)}
                        </LinkTableCell>

                        <LinkTableCell
                            href={href}
                            numeric={true}
                        >
                            {prismaRequestOffer.netPrice !== null ? formatPrice(prismaRequestOffer.netPrice) : '-'}
                        </LinkTableCell>

                        <LinkTableCell href={href}>
                            <PrismaManufacturerStatusView
                                status={manufacturerStatus !== null ? manufacturerStatus : 'Inactive'}
                            />
                        </LinkTableCell>
                    </TableRow>
                )

                first = false
                return elements
            },
            prismaRequestOffersWithManufacturerStatus,
        ))
    }
}

export const PrismaRequestOverviewView =
    injectSheet<Properties>(styles)(
        ({classes, state, dispatch}: WithClasses<Properties>) => {
            const
                {prismaRequestsWithOffersForList} = state
            return (
                <div className={classes.root}>
                    <div className="navigation">
                        <AppBar
                            title="Prisma-Projekte"
                            className="navigation__bar"
                            iconElementLeft={
                                <IconButton
                                    onClick={
                                        () => dispatch(
                                            {type: 'MenuButtonClicked'},
                                        )
                                    }
                                >
                                    <NavigationMenu/>
                                </IconButton>}
                        />
                    </div>
                    <div className={`overview ${classes.overviewWrapper}`}>
                        <LinearProgress
                            mode="indeterminate"
                            style={{visibility: state.loading ? 'visible' : 'hidden'}}
                        />
                        <div className="overview__content">
                            <PrismaRequestFilterContainer
                                state={state.prismaRequestFiltering}
                                dispatch={
                                    subAction => dispatch({
                                                              type: 'PrismaRequestFilteringModuleAction',
                                                              subAction,
                                                          })
                                }
                            />
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ID</TableCell>
                                        <TableCell/>
                                        <TableCell>Produktname</TableCell>
                                        <TableCell numeric={true}>
                                            Auflage
                                        </TableCell>
                                        <TableCell numeric={true}>
                                            Anzahl Vorlagen
                                        </TableCell>
                                        <TableCell numeric={true}>
                                            Gesamtstückzahl
                                        </TableCell>
                                        <TableCell>Art</TableCell>
                                        <TableCell>Typ</TableCell>
                                        <TableCell numeric={true}>
                                            Abgegebener Preis
                                        </TableCell>
                                        <TableCell>Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        R.map(generateTableEntry, prismaRequestsWithOffersForList.data)
                                    }

                                </TableBody>
                            </Table>
                        </div>
                    </div>
                    <Footer>
                        <PageSize
                            itemsPerPage={state.prismaRequestsWithOffersForList.pageSection.itemsPerPage}
                            onChange={
                                value => dispatch({
                                                      type: 'ItemsPerPageChanged',
                                                      value,
                                                  })
                            }
                        />
                        <PaginationView
                            pagination={state.prismaRequestsWithOffersForList}
                            onNavigate={navigation => dispatch({
                                                                   type: 'PaginationNavigation',
                                                                   navigation,
                                                               })}
                        />
                    </Footer>
                </div>
            )
        },
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/PrismaRequestOverview/PrismaRequestOverviewView.tsx